import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import main from '../../img/AccountSpecification/main.png'

import Fade from 'react-reveal/Fade'

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative bg-[#131313]">
            <div className="max-w-[1220px] mx-[20px] xl:h-[535px] xl:mx-auto flex flex-col xl:flex-row justify-between">
                <div className="flex flex-col items-start">
                    <Fade left><p className="text-[32px] xl:text-[48px] manrope text-white mt-[40px] xl:mt-[100px] font-[500] leading-[1.2] xl:max-w-[706px]">{t('account.1')}</p></Fade>
                    <Fade left delay={200}><p className="manrope text-[12px] xl:text-[14px] xl:max-w-[455px] font-[300] text-[#FFFFFFB2] mt-[20px] xl:mt-[40px]">{t('account.2')}</p></Fade>
                    <Fade left delay={300}><Button className={'mt-[20px] xl:mt-[40px]'} main/></Fade>
                </div>
                <Fade right delay={500}><img src={main} className="mt-[40px] xl:mt-[60px]" alt="" /></Fade>
            </div>
        </div>
    );
}

export default Main;